import { useEffect } from "react";
import { setSeo } from "@/utils/seo";
import { Link } from "react-router-dom";
import { Navbar, Footer } from "@/components/Layout";

export default function Privacy() {
  useEffect(() => {
    setSeo(
      "Privacy Policy | HairHelp",
      "Privacy Policy di HairHelp: come raccogliamo e trattiamo i dati inviati tramite il modulo di richiesta consiglio. L'email viene usata solo per risponderti."
    );
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-manrope text-charcoal">
      <Navbar />
      <section className="mx-auto max-w-3xl px-6 py-16 md:py-24" data-testid="privacy-page">
        <h1 className="font-editorial text-3xl font-semibold text-foreground sm:text-4xl" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <div className="mt-8 space-y-6 text-base leading-relaxed text-muted-foreground">
          <p>
            La tua privacy è importante per noi. Questa informativa spiega quali dati raccogliamo
            tramite HairHelp, come li utilizziamo e quali diritti puoi esercitare.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Titolare del trattamento</h2>
          <p>
            Il titolare del trattamento dei dati è HairHelp. Per qualsiasi richiesta relativa ai
            tuoi dati puoi contattarci all'indirizzo{" "}
            <a href="mailto:admin@hairhelp.studio" className="font-semibold text-sage underline" data-testid="privacy-contact-link">
              admin@hairhelp.studio
            </a>.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Quali dati raccogliamo</h2>
          <p>
            Raccogliamo esclusivamente i dati che ci fornisci volontariamente tramite il modulo
            &ldquo;Chiedici un consiglio&rdquo;: il tuo nome (facoltativo), il tuo indirizzo email
            e il contenuto della richiesta che ci invii.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Come utilizziamo i dati</h2>
          <p>
            Utilizziamo il tuo indirizzo email unicamente per risponderti in privato alla richiesta
            inviata. Non utilizziamo i tuoi dati per finalità pubblicitarie e non li cediamo a terzi.
          </p>
          <p>
            Solo se fornisci un consenso separato e facoltativo, potremo inviarti in futuro guide
            gratuite e aggiornamenti. Puoi revocare questo consenso in qualsiasi momento, senza che
            ciò influisca sulla risposta alla tua richiesta.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Conservazione e base giuridica</h2>
          <p>
            Il trattamento si basa sul tuo consenso. Conserviamo i dati per il tempo necessario a
            gestire la tua richiesta e, in caso di consenso alle comunicazioni, fino a quando non
            decidi di revocarlo.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">I tuoi diritti</h2>
          <p>
            In qualsiasi momento puoi richiedere l'accesso, la rettifica o la cancellazione dei tuoi
            dati, oppure opporti al loro trattamento, scrivendo a{" "}
            <a href="mailto:admin@hairhelp.studio" className="font-semibold text-sage underline">
              admin@hairhelp.studio
            </a>.
          </p>
        </div>
        <Link
          to="/fai-una-domanda"
          data-testid="privacy-cta"
          className="mt-10 inline-block rounded-full bg-sage px-6 py-3 text-sm font-semibold text-white transition-transform duration-300 ease-out hover:scale-105 active:scale-95"
        >
          Chiedici un consiglio →
        </Link>
      </section>
      <Footer />
    </div>
  );
}
